// betrieb.js – Stammdaten des Betriebs: Name, Rechtsname, Inhaber, Anschrift, Telefon, E-Mail, Erreichbarkeit, Einsatzorte.
// Einzige Quelle für die NAP-Blöcke (Fußzeile, Impressum, Datenschutz, Kontaktseite, Notdienst), die Ortsliste (Einsatzgebiet),
// die Referenzkarte und die Strukturdaten (src/components/Strukturdaten.js). Dieselben Angaben in derselben Schreibweise
// gehören ins Google-Unternehmensprofil (docs/PRODUKTIV.md, Abschnitt 9), sonst wertet Google sie als verschiedene Betriebe.
// Von Hand gepflegt bleiben: Titel und og:site_name in public/index.html, name in public/manifest.json, SITE in src/usePageMeta.js
// und scripts/prerender.mjs, die Ortsliste als Fließtext in src/data/faq.js sowie Marke, Inhaber und Ort in Vorzeilen, Seitentiteln,
// Fließtext, Bildunterschriften und Alt-Texten. Ändert sich name, inhaber oder ort: src/ nach der bisherigen Schreibweise durchsuchen.
// Die Logo-Grafik schreibt „Land- & Forsttechnische …“; in Texten gilt „und“ (Wortlaut der Gewerbeanmeldung vom Inhaber bestätigen lassen).
const betrieb = {
  // Marke, unter der der Betrieb auftritt (Website, Logo, Instagram); Schreibweise mit Leerzeichen um das &
  name: "Forst & Flur",
  // Geschäftsbezeichnung des Einzelunternehmens (§ 5 DDG), immer mit „und“; nur Impressum, Datenschutz, Copyright, legalName
  rechtsname: "Land- und Forsttechnische Dienstleistungen Stoltenberg",
  inhaber: "Lasse Stoltenberg",
  strasse: "Schönberger Landstraße 38",
  plz: "24253",
  ort: "Probsteierhagen",
  region: "Schleswig-Holstein",
  land: "DE",
  // Koordinaten des Betriebssitzes (auch Kartenmarker in src/data/orte.js). Google empfiehlt mindestens 5 Nachkommastellen;
  // einen genaueren Wert kann nur der Inhaber bestätigen (docs/PRODUKTIV.md, Abschnitt 9).
  geo: { lat: 54.35459, lon: 10.27424 },
  telefon: "+49 176 317 50 537", // sichtbare Schreibweise, überall gleich
  telefonE164: "+4917631750537", // maschinell: tel:-Links, Strukturdaten
  email: "lasse.stoltenberg@forstundflur.de",
  // Telefonische Erreichbarkeit (Kontaktseite). Dieselben Zeiten stehen als Öffnungszeiten in den Strukturdaten
  // und müssen im Unternehmensprofil stehen. Kein 24-Stunden-Versprechen: der Notdienst sagt nur „sobald es irgendwie geht“.
  erreichbarkeit: {
    text: "Montag bis Samstag, 8 bis 16 Uhr",
    kurz: "Mo–Sa, 8–16 Uhr", // Fußzeile
    tage: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    von: "08:00",
    bis: "16:00",
  },
  website: "https://www.forstundflur.de", // Hauptadresse mit www (Canonical, Sitemap)
  instagram: "https://www.instagram.com/forst_und_flur/",
  // Orte des Einsatzgebiets (Seite /einsatzgebiet, areaServed in den Strukturdaten): nahe Orte zuerst, dann die weiteren
  einsatzorte: ["Kiel", "Schönberg (Holstein)", "Plön", "Preetz", "Lütjenburg", "Lübeck", "Neumünster", "Eckernförde", "Rendsburg"],
};

export const telefonLink = `tel:${betrieb.telefonE164}`;
export const mailLink = `mailto:${betrieb.email}`;
// Marke und Rechtsname gemeinsam in einer Zeile (Copyright, Fließtext)
export const kombiniert = `${betrieb.name} – ${betrieb.rechtsname}`;

export default betrieb;
